export const GET_ORDERS = "GET_ORDERS";
export const GET_ORDER = "GET_ORDER";
export const GET_ORDER_TOKEN = "GET_ORDER_TOKEN";
export const GET_ORDER_ERR = "GET_ORDER_ERR";
export const GET_QR = "GET_QR";
export const GET_CHARGE_STATUS = "GET_CHARGE_STATUS";

export const POST_PAY_CREDIT = "POST_PAY_CREDIT";
export const POST_PAY_CREDIT_ERR = "POST_PAY_CREDIT_ERR";
export const POST_ORDER_STATUS = "POST_ORDER_STATUS";
export const POST_ORDER_STATUS_ERR = "POST_ORDER_STATUS_ERR";